<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">
          <div class="settings-header">
            Units of Measure
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Setting Dashboard</el-button>
            </div>
          </div>
          <div class="wrap__tree">
            <div class="nav-tree">
              <el-button @click="openModalAdd" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">{{$t('general_add')}} {{btnText}}</el-button>
            </div>
            <el-table
                max-height="650"
                :data="tableData"
                :empty-text="$t('general_noData')"
                style="width: 100%">
              <el-table-column
                  label="ID"
                  type="index"
                  width="70">
              </el-table-column>
              <el-table-column
                  prop="code"
                  label="Unit"
                  width="270">
              </el-table-column>
              <el-table-column
                  prop="name"
                  :label="$t('settings_accountThink_units_name')">
              </el-table-column>
              <el-table-column
                  width="120"
                  :label="$t('settings_accountThink_units_operations')">
                <template slot-scope="scope">
                  <el-button
                      size="mini"
                      type="primary"
                      plain
                      icon="el-icon-edit"
                      @click="handleEdit(scope.$index, scope.row)"></el-button>
                  <el-button
                      size="mini"
                      type="danger"
                      plain
                      icon="el-icon-delete"
                      @click="handleDelete(scope.$index, scope.row)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <!-- add -->
    <sweet-modal blocking :title="`${$t('general_add')} ${btnText}`" ref="openModal" class="modal" v-on:close="closeModal">
      <el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="name">
              <el-input :label="$t('settings_accountThink_units_name')" v-model="form.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="code">
              <el-input :label="$t('settings_accountThink_units_code')" v-model="form.code"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('openModal')">{{$t('general_cancel')}}</el-button>
          <el-button @click="addItem('form')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>

    <!-- edit -->
    <sweet-modal blocking :title="`${$t('general_edit')} ${btnText}`" ref="openModalEdit" class="modal" v-on:close="closeModalEdit">
      <el-form :model="formEdit" ref="formEdit" status-icon :rules="rulesEdit" label-width="0" class="demo-ruleForm">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="name">
              <el-input :label="$t('settings_accountThink_units_name')" v-model="formEdit.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="code">
              <el-input :label="$t('settings_accountThink_units_code')" v-model="formEdit.code"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('openModalEdit')">{{$t('general_cancel')}}</el-button>
          <el-button @click="editItem('formEdit')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>
  </div>
</template>

<script>
import axios from 'axios'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

export default {
  name: 'UnitsOfMeasure',
  components: {
    SweetModal
  },
  mounted() {
    this.loadList()
  },
  data() {
    return {
      btnText: 'Unit of Measure',
      tableData: [],
      selectedRowId: '',
      form:{
        name: '',
        code: ''
      },
      formEdit:{
        name: '',
        code: ''
      },
      rules: {
        name: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        code: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ]
      },
      rulesEdit: {
        name: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        code: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ]
      },
    }
  },
  methods: {
    openModalAdd(){
      this.$refs.openModal.open()
    },
    loadList(){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .get(`/api/v1/items/units/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.tableData = response.data.list
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
    },
    handleEdit(index, row) {
      console.log(row)
      this.selectedRowId = row.id
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .get(`/api/v1/items/units?id=${row.id}`)
          .then(response => {
            this.$refs.openModalEdit.open()
            this.formEdit.name = response.data.item.name
            this.formEdit.code = response.data.item.code
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
    },
    addItem(form){
      this.$refs[form].validate((valid) => {
        if (valid) {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .post(`/api/v1/items/units?companyId=${this.$route.query.companyId}`, {
                name: this.form.name,
                code: this.form.code
              })
              .then(response => {
                this.$refs.openModal.close()
                this.loadList()
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
        }else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    editItem(formEdit){
      this.$refs[formEdit].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .put(`/api/v1/items/units?id=${this.selectedRowId}`, this.formEdit)
              .then(response => {
                this.$refs.openModalEdit.close()
                this.loadList()
                loader.hide()
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
              });
        }else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleDelete(index, row) {
      this.selectedRowId = row.id

      this.$confirm('This will permanently delete the Unit. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'info'
      }).then(() => {
        this.$message({
          type: 'success',
          message: 'Delete completed'
        });

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/items/units?id=${this.selectedRowId}`)
            .then(response => {
              this.loadList()
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        });
      });
    },
    closeModal(){
      this.form.name = ''
      this.form.code = ''
      this.$refs['form'].resetFields();
    },
    closeModalEdit(){
      this.formEdit.name = ''
      this.formEdit.code = ''
      this.$refs['formEdit'].resetFields();
    },
    modalCancel(ref) {
      this.$refs[ref].close();
    },
    routerLink(page) {
      this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
    },
  }
}
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>